module.exports = __webpack_public_path__ + "img/vertical&box.675e88dd.jpg";